import { useQuery } from '@tanstack/react-query'
import { useZone } from '~/team_tools/components/timezone'
import { JsonRpcError } from '~/types'
import { EarningFeeStatistic } from '../types'

/** `window` is a custom range from the dashboard, when one is chosen. */
export const useStatisticEarningFee = (window: Record<string, any> = {}) => {
    // "Today", "Week" and "Month" are days in the zone the shell names, the
    // same days the chart under the tiles draws.
    const [zone] = useZone()
    return useQuery<EarningFeeStatistic, JsonRpcError>({
        queryKey: ['statistic.earning_fee', zone, window],
        queryFn: async () => {
            const res = await fetch('/rpc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'gameapi.statistic.earnings_fee',
                    params: { tz: zone, ...window },
                }),
            })
            const data = await res.json()
            if (data.error) {
                throw data
            } else {
                return data.result
            }
        },
        retry: false,
    })
}
